import { TSupportedIntroducerTypes } from 'lendingApi/lendingApi.types';

const UNLOCK_URLS = {
  credit_facility: {
    accountant: 'https://share.hsforms.com/1Jqq_43vXTHKUrf4FMZg99Q3rrot',
    broker: 'https://share.hsforms.com/1O0ylpCL2RqCdH2EPYUFm_Q3rrot',
    sales: '',
    iwoca_sales: '',
  },
  flexi_24: {
    accountant: 'https://hubs.li/Q012QCDf0',
    broker: 'https://hubs.li/Q012QBL20',
    sales: '',
    iwoca_sales: '',
  },
  iwocaPay: {
    accountant: 'https://share.hsforms.com/1yzBiEQ5ATj-Ej5ISflQgxA3rrot',
    broker: 'https://share.hsforms.com/1pnpn4NIxQu6PORTocWwMIw3rrot',
    sales: '',
    iwoca_sales: '',
  },
};

export function getUnlockURL(
  productType: keyof typeof UNLOCK_URLS,
  introducerType: TSupportedIntroducerTypes = 'broker',
): string {
  if (introducerType === 'other') {
    return UNLOCK_URLS[productType]['broker'];
  }

  return UNLOCK_URLS[productType][introducerType];
}
